import { Component, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { OfftopicService } from 'src/app/api/offtopic.service';

@Component({
  selector: 'app-add-ot',
  templateUrl: './add-ot.component.html',
  styleUrls: ['./add-ot.component.scss'],
})
export class AddOtComponent implements OnInit {

  sendTo: any;
  subject: string;
  message: string;
  title: string = "New Message"
  threadId: any;
  parentOTId: any;
  private isToastShowing = false;

  isSendMessageClicked: boolean = false;

  constructor(private modalController: ModalController,
    private offtopicService: OfftopicService,
    private toastController: ToastController
  ) { }


  ngOnInit() {
    if (this.parentOTId) {
      this.title = "Reply All";
    }
    if (this.sendTo && this.parentOTId) {
      this.title = "Reply";
    }
  }


  dismissModal() {
    this.modalController.dismiss();
  }

  async sendMessage() {
    if (this.validateForm()) {
      await this.createOfftopic();
    }

  }

  async createOfftopic() {

    let offtopic: any = {
      Subject: encodeURIComponent(this.subject),
      Body: encodeURIComponent(`${this.message}`),
    }

    //  if parent ot and send To both are present the it will be reply
    // if only parent otid present then it will be reply All 
    if (this.parentOTId) {
      offtopic.parentOTId = this.parentOTId;
    }
    if (this.sendTo) {
      offtopic.SendTo = this.sendTo;
    }
    if (this.threadId) {
      offtopic.threadId = this.threadId;
    }
    this.isSendMessageClicked = !this.isSendMessageClicked
    this.offtopicService.createOfftopic(offtopic).then((response) => {
      if (response) {
        if (response.status == 'failure') {
          this.modalController.dismiss(response.status);
          this.presentToast(response.message, 'danger');
        }
        else {
          this.modalController.dismiss(response.status);
          this.presentToast('Your message sent succcessfully', 'success');

        }
        this.isSendMessageClicked = !this.isSendMessageClicked;
      }
    }).catch((error) => {
    })

  }


  validateForm(): boolean {
    if (!this.subject || !this.message) {
      this.presentToast('Please enter all fields', 'danger');
      return false;
    }
    return true;
  }

  async presentToast(message: string, color) {
    if (this.isToastShowing) {
      return;
    }


    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      position: 'top',
      color: color,
      cssClass: 'my-toast-class'
    });
    // Set isToastShowing to true before presenting the toast
    this.isToastShowing = true;

    toast.present();

    // Reset isToastShowing to false after the toast has been dismissed
    await toast.onDidDismiss();
    this.isToastShowing = false;


  }


}
